var _path, _path2, _path3, _path4, _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptySearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 95,
    viewBox: "0 0 102 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.97168 81.0002C0.97168 88.4294 23.3695 94.4579 51.0003 94.4579C78.631 94.4579 101.029 88.4294 101.029 81.0002C101.029 73.5659 78.631 67.5425 51.0003 67.5425C23.3695 67.5425 0.97168 73.5659 0.97168 81.0002Z",
    fill: "#F7F7F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2188 77.5425C17.2188 78.0948 17.6665 78.5425 18.2188 78.5425H83.9714C84.5237 78.5425 84.9714 78.0948 84.9714 77.5425V22.8029L65.0821 1.54248H18.2187C17.6665 1.54248 17.2188 1.9902 17.2188 2.54248V77.5425Z",
    fill: "#F5F5F5",
    stroke: "#D9D9D9",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4443 20.4082C66.4443 20.9605 66.8921 21.4082 67.4443 21.4082H83.6608L66.4443 3.069V20.4082Z",
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8356 69.0735L78.8215 58.0594C80.5307 55.8498 81.4552 53.1482 81.4552 50.3067C81.4552 46.9054 80.1278 43.7161 77.7273 41.3114C75.3269 38.9067 72.1291 37.5835 68.732 37.5835C65.3349 37.5835 62.1371 38.911 59.7367 41.3114C57.332 43.7118 56.0088 46.9054 56.0088 50.3067C56.0088 53.7038 57.3362 56.9016 59.7367 59.302C62.1371 61.7067 65.3307 63.0299 68.732 63.0299C71.5735 63.0299 74.2708 62.1054 76.4804 60.4005L87.4945 71.4103C87.5268 71.4426 87.5651 71.4682 87.6074 71.4857C87.6496 71.5032 87.6948 71.5122 87.7405 71.5122C87.7862 71.5122 87.8314 71.5032 87.8736 71.4857C87.9158 71.4682 87.9542 71.4426 87.9865 71.4103L89.8356 69.5654C89.8679 69.5331 89.8935 69.4948 89.911 69.4526C89.9285 69.4104 89.9375 69.3651 89.9375 69.3194C89.9375 69.2737 89.9285 69.2285 89.911 69.1863C89.8935 69.1441 89.8679 69.1057 89.8356 69.0735ZM75.4499 57.0246C73.6516 58.8185 71.2682 59.8067 68.732 59.8067C66.1958 59.8067 63.8124 58.8185 62.0141 57.0246C60.2202 55.2264 59.232 52.8429 59.232 50.3067C59.232 47.7705 60.2202 45.3828 62.0141 43.5889C63.8124 41.7949 66.1958 40.8067 68.732 40.8067C71.2682 40.8067 73.6559 41.7906 75.4499 43.5889C77.2438 45.3871 78.232 47.7705 78.232 50.3067C78.232 52.8429 77.2438 55.2306 75.4499 57.0246Z",
    fill: "#D9D9D9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24.9717,
    y: 18.5425,
    width: 29,
    height: 2,
    fill: "#D9D9D9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24.9717,
    y: 26.5425,
    width: 29,
    height: 2,
    fill: "#D9D9D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24.9717,
    y: 34.5425,
    width: 12,
    height: 2,
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptySearch);
export default __webpack_public_path__ + "static/media/emptySearch.3bd97a1093bab401a3c330c422fdb210.svg";
export { ForwardRef as ReactComponent };